// A single-root shell tab with session push sets the user its page was rendered for. Every
// RecruitApiClient request then names that user, so the server refuses requests once another tab
// signs this browser in as someone else (409 session_user_changed). JSON requests also ask for JSON,
// so an ended session answers 401 rather than redirecting to the sign-in page.
let shellUserId: number | null = null;

export const setShellUser = (userId: number | null): void => {
  shellUserId = userId;
};

export const shellRequestHeaders = (json: boolean): Record<string, string> => {
  if (shellUserId === null) return {};
  return {
    ...(json ? { Accept: 'application/json' } : {}),
    'X-Scout-Shell-User': String(shellUserId)
  };
};
